<template>
    <el-drawer title="审核" @close="closeDialog"  direction="ltr" size="650px"  :visible.sync="dialogVisible">
       <slot></slot>
      <el-drawer title="证件信息" size="100%" @close="closeDialog"   class="rightDrawer"
      :modal-append-to-body="false" :modal="false"  :visible.sync="dialogVisible">
        <div class="imgbox" v-for="(item,index) in imgList" :key="index" >
            <el-image
              style="width:100%px;min-height:200px;"
              :src="item.ImgUrl"
              :preview-src-list="getSrcList(index,imgListUrl)">
            </el-image>
            <h4 style="text-align: center;">{{item.name}}</h4>
        </div>
      </el-drawer>
  </el-drawer>

</template>

<script>
export default {
  name: 'lookVoucher',
  props: {
    imgList: {
      type: Array,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: []
    }
  },
  data () {
    return {
      dialogVisible: true,
      imgListUrl: []
    }
  },
  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
    console.log(this.imgList)
    this.imgList.forEach(item => {
      this.imgListUrl.push(item.ImgUrl)
    })
  },
  methods: {
    // 点击凭证放大
    getSrcList (index, arr) {
      return arr.slice(index).concat(arr.slice(0, index))
    },
    closeDialog () {
      this.$emit('destroy')
    }
  },
  destroyed () {

  }
}
</script>

<style scoped lang='less'>
.hidden /deep/.el-upload--picture-card{
  display: none;
}
/deep/.el-form--inline .diqu .el-form-item__content{
      flex-direction: row;
}
/deep/.el-image {
  margin: 10px;
}
</style>
